module.exports = __webpack_public_path__ + "static/BBIS-logo-e625d7277c7af34b0761e60a0473cf79.png";